module.exports = __webpack_public_path__ + "webfonts/398F09_0_unhinted_0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/webfonts/398F09_0_unhinted_0.woff
// module id = 59
// module chunks = 0